"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createStyles = _interopRequireDefault(require("@material-ui/core/styles/createStyles"));
var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));
var _colors = require("../../utils/colors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var useStyles = (0, _makeStyles.default)(theme => (0, _createStyles.default)({
  darkIconColor: {
    color: theme.palette.common.black
  },
  lightIconColor: {
    color: (0, _colors.getRgba)(theme.palette.common.white, 0.7)
  },
  large: {
    // TODO OVERRIDE
    fontSize: theme.typography.pxToRem(48)
  },
  medium: {
    // TODO OVERRIDE
    fontSize: theme.typography.pxToRem(30)
  },
  small: {
    // TODO OVERRIDE
    fontSize: theme.typography.pxToRem(21)
  }
}), {
  name: 'SocialMediaIconLink'
});
var _default = exports.default = useStyles;